@if (loading()) {
  <div class="flex items-center justify-center">
    <app-dots-spinner />
  </div>
} @else {
  <button
    mat-menu-item
    data-testid="creator-campaign-export-toggle-briefing"
    *hasPermission="[EPermissions.campaignUpdateOwn]"
    (click)="onUpdateBriefing($event)"
  >
    @if (!creatorCampaignExports().get(creatorId())) {
      <span>{{ 'pages.campaignDetails.table.creatorCampaignExport.createBriefing' | translate }}</span>
    } @else if (creatorCampaignExports().get(creatorId())?.isActive) {
      <span>{{ 'pages.campaignDetails.table.creatorCampaignExport.disableBriefing' | translate }}</span>
    } @else {
      <span>{{ 'pages.campaignDetails.table.creatorCampaignExport.enableBriefing' | translate }}</span>
    }
  </button>

  @if (creatorCampaignExports().get(creatorId())?.isActive) {
    <button mat-menu-item (click)="onCopyBriefingUrl($event)">
      <span>{{ 'pages.campaignDetails.table.creatorCampaignExport.copyBriefingUrl' | translate }}</span>
    </button>

    <button mat-menu-item data-testid="creator-campaign-export-open-briefing" (click)="onOpenBriefing($event)">
      <span>{{ 'pages.campaignDetails.table.creatorCampaignExport.openBriefing' | translate }}</span>
    </button>
  }
}
